const DEFAULT_HOST = "dev.0xflow.io";

export const HOST = import.meta.env.VITE_REACT_APP_API_HOST || DEFAULT_HOST;

// export const API_URL = window.origin.includes("localhost") ? `https://${HOST}` : "";
export const API_URL = `https://${HOST}`;
export const API_URL_WS = `${API_URL}/api/ws/`;

export const TG_SUPPORT = import.meta.env.VITE_TG_SUPPORT || "telegram";
export const DOWNLOAD_CHECKER_LINK =
  import.meta.env.VITE_DOWNLOAD_CHECKER_LINK || "https://test.ru/app.apk";
